import { render, staticRenderFns } from "./SupaLatestPage.vue?vue&type=template&id=328bf2dc&scoped=true&"
import script from "./SupaLatestPage.vue?vue&type=script&lang=js&"
export * from "./SupaLatestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328bf2dc",
  null
  
)

export default component.exports